export default __webpack_public_path__ + "ce3e56cfadd0a322a4918752d35cdc34.png";